module.exports = __webpack_public_path__ + "static/media/img_featuredissues-sextingonline_grooming_CH.72ccbbc3.png";